module.exports = __webpack_public_path__ + "static/media/amiOrganicsLogo.2f76f033.svg";